import HeaderfulContainer from 'src/v2/components/molecules/headerfulContainer'
import { Lookup } from 'src/v2/components/molecules/lookup'
import styled from 'styled-components'
import Input from 'src/v2/components/atoms/input'

export const Container = styled(HeaderfulContainer)`
  && {
  }
`

export const ContentContainer = styled.div`
  && {
    display: flex;
  }
`

export const NameFilter = styled(Input)`
  && {
    width: 30%;
    margin-right: 24px;
  }
`

export const KitchensSelect = styled(Lookup)`
  && {
    width: 30%;
  }
`
